const AUTH_STORAGE_KEY = "ekman_auth_user";

// Admin email
const ADMIN_EMAILS = ["ekmanbyekta@gmail.com", "shwaans.bepositive@gmail.com"];

export const getAuthUser = () => {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = localStorage.getItem(AUTH_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const loginWithGoogle = (userData) => {
  const isAdmin = ADMIN_EMAILS.includes(userData.email?.toLowerCase());
  const user = {
    id: userData.email,
    name: userData.name,
    email: userData.email,
    picture: userData.picture,
    role: isAdmin ? "admin" : "customer",
    isGoogleUser: true,
  };
  localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(user));
  return { success: true, user };
};

export const logoutUser = () => {
  if (typeof window === "undefined") {
    return;
  }
  localStorage.removeItem(AUTH_STORAGE_KEY);
};

export const hasAllowedRole = (allowedRoles = []) => {
  const user = getAuthUser();
  if (!user) {
    return false;
  }
  return allowedRoles.includes(user.role);
};
